module.exports = __webpack_public_path__ + "static/SVHome-06-eea5892e42be0c067ecffd11fe109905.png";